import { apiClient } from '@/helpers/api'
import { defineStore } from 'pinia'
import { useCardStore } from '@/stores/CardStore'
import { useBatchStore } from '@/stores/BatchStore'

export const useConfigStore = defineStore('ConfigStore', {
  state: () => ({
    config: {},
    loadingConfig: false,
    loadingConfigInBackground: false,
    hmacHash: null,
    stripeCustomerId: null,
    ignoreConfigUpdate: false,
  }),

  getters: {
    getConfigField() {
      return (key) => {
        return this.config ? this.config[key] : {}
      }
    },
    
    topPlan() {
      if (!this.config?.plans?.length) return null

      return this.config.plans[this.config.plans.length - 1]
    },

    currentPlan() {
      if (!this.config?.plans?.length) return {}

      return this.config.plans.find(plan => {
        return this.config.subscription?.plan_id === plan.id
      })
    },

    currentPlanIndex() {
      if (!this.config?.plans?.length) return null

      return this.config.plans.findIndex(plan => {
        return this.config.subscription?.plan_id === plan.id
      })
    },
    reactivateAccountModal() {
      return !this.config || this.config.hasActiveSubscription !== false
    }
  },

  actions: {
    async fetchConfigs(options) {
      if (this.loadingConfigInBackground) return

      const cardStore = useCardStore()
      const batchStore = useBatchStore()

      try {
        if (!options?.withoutLoader) {
          this.loadingConfig = true
        }

        this.loadingConfigInBackground = true

        const { data } = await apiClient().get('/config')

        this.config = data
        this.hmacHash = data.hmac_hash
        this.stripeCustomerId = data.stripe_customer_id

        this.loadingConfig = false
        this.loadingConfigInBackground = false

        cardStore.setCardStoreFields({
          grader: data.graders
        })

        batchStore.selectedBatch && batchStore.updateSelectedBatch({ config: data })
      } catch (error) {
        this.loadingConfig = false
        this.loadingConfigInBackground = false
        console.log('fetchConfigs error GlobalStore', error)
      }
    }
  }
})
